import React from "react";

const WhyUs = () => {
  const features = [
    {
      icon: "fa-user-tie",
      title: "Over 25 years Of Experience",
    },
    {
      icon: "fa-atom",
      title: "State of the Art Technology",
    },
    {
      icon: "fa-user-md",
      title: "Experienced Medical Doctors",
    },
  ];

  return (
    <section className="container text-center">
      {/* Title */}
      <div className="d-flex flex-column align-items-center">
        <h2
          className="fw-bold text-uppercase px-5 py-2"
          style={{
            color: "#b78c35",
            borderRadius: "5px",
            display: "inline-block",
          }}
        >
          Why Choose Elite Body Home?
        </h2>
        <p className="mt-3 text-muted" style={{ maxWidth: "750px" }}>
          At Elite Body Home, we combine expertise with a patient-first approach
          to ensure you receive the best possible care. Our qualified
          practitioners are highly skilled in administering Botox injections,
          ensuring safety, precision, and optimal results.
        </p>
      </div>

      {/* Feature Cards */}
      <div className="row justify-content-center mt-4 g-3">
        {features.map((feature, index) => (
          <div key={index} className="col-12 col-sm-6 col-md-3 d-flex justify-content-center">
            <div
              className="text-center p-4 shadow-sm feature-card"
              style={{
                backgroundColor: "#fcf8ed",
                borderRadius: "12px",
                border: "1px solid #b78c35",
                width: "90%",
                transition: "all 0.3s ease-in-out",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              }}
            >
              <i  style={{color: "#b78c35"}} className={`fas ${feature.icon} fa-3x `}></i>
              <h6 className="mt-3 fw-bold">{feature.title}</h6>
            </div>
          </div>
        ))}
      </div>

     
    </section>
  );
};

export default WhyUs;
